export const spokenText = (value) => String(value || '')
  .replace(/\[([^\]]+)\]\([^)]*\)/g, '$1')
  .replace(/^\s{0,3}#{1,6}\s*/gm, '')
  .replace(/^\s*[-*]\s+/gm, '')
  .replace(/^\s*\d+[.)]\s+/gm, '')
  .replace(/(?<!\w)(?:\*\*|__|\*|_|`)(?=\S)|(?<=\S)(?:\*\*|__|\*|_|`)(?!\w)/g, '')
  .replace(/[ \t]+/g, ' ').trim();
